import React from "react";
import startOfDay from "date-fns/startOfDay";
import differenceInDays from "date-fns/differenceInDays";

import { Zero } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/Zero";
import { PastDue } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/PastDue";
import { DueToday } from "blox_components/Billing/TotalAmountDue/Components/CountDownSVGs/DueToday";
import { BillingApi, BillingUtils, INVOICES_STATUS } from "services/billing";

const selectCalendarImage = (invoices, status) => {
  const today = startOfDay(new Date());

  switch (status) {
    case INVOICES_STATUS.DUE_TODAY:
      return <DueToday />;
    case INVOICES_STATUS.OVERDUE:
      BillingUtils.sortDueDate(invoices.overdue).reverse();
      const earliestOverdueDate = invoices.overdue[0].due;
      const daysOverdue = differenceInDays(
        today,
        new Date(earliestOverdueDate)
      );
      const daysOverdueStr = `${daysOverdue} ${
        daysOverdue > 1 ? "DAYS" : "DAY"
      }`;

      return <PastDue text={daysOverdueStr} />;
    case INVOICES_STATUS.DUE_FUTURE:
      const sortedFutureInvoices = BillingUtils.sortDueDate(
        invoices.dueFuture
      ).reverse();
      const latestDueFutureDate = sortedFutureInvoices[0].due;
      const diff = differenceInDays(today, new Date(latestDueFutureDate));

      return BillingApi.getCountDownNumber(diff);
    default:
      return <Zero text="" />;
  }
};

const CalendarDay = ({ invoices }) => {
  if (!invoices) {
    return (
      <div className="calendar-day">
        <Zero text="" />
      </div>
    );
  }

  const { invoices: splitInvoices, status } =
    BillingUtils.getInvoiceStatus(invoices);

  return (
    <div className="calendar-day">
      {selectCalendarImage(splitInvoices, status)}
    </div>
  );
};

export default CalendarDay;
